export type ResolutionItem = {
	width: number;
	height: number;
	framerate?: number;
};

type ResolutionList = ResolutionItem[];

export default ResolutionList;

/**
 * Prepare simply usable list which all displays has to currently support at least.
 * This constant is to simplifying the backward compatibility of all platforms which doesn't support more resolutions yet.
 */
export const ONLY_FULL_HD_RESOLUTION_LIST: ResolutionList = [{ width: 1920, height: 1080 }];
